import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoadJsService } from '../../load-js/load-js.service';
import { FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.scss']
})
export class ForgetPasswordComponent implements OnInit {

  constructor(  
    private router: Router,  
    private fb: FormBuilder,  
    private loadjs: LoadJsService
  ) { }

  formForgetpass = this.fb.group({
    email: [''],
  });

  title = 'Please input your Email Address';
  message = '';

  ngOnInit() {
    this.loadScripts();
  } 

  private loadScripts() {
    this.loadjs.loadScriptloginJs()
  }

  tea() {
    if(this.formForgetpass.value.email == 'login'){
      this.router.navigate(['/login']);
    }else{
      // console.log(this.formForgetpass.value);
      this.message = this.formForgetpass.value.email + ' Email Not Found!';
    }
  }

}
